import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HandleError } from "./service-helper";
import { Task } from "../models/task";
import { environment } from "src/environments/environment";
const BASE_API = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class TaskService {
  private taskUrl = BASE_API + "/gantt";

  constructor(private http: HttpClient) {}
  get(): Promise<any> {
    return this.http.get(this.taskUrl).toPromise().catch(HandleError);
  }

  insert(task: Task): Promise<Task> {
    return this.http.post(this.taskUrl, task).toPromise().catch(HandleError);
  }

  update(task: Task): Promise<void> {
    return this.http
      .put(`${this.taskUrl}/${task.id}`, task)
      .toPromise()
      .catch(HandleError);
  }

  remove(id: number): Promise<void> {
    return this.http
      .delete(`${this.taskUrl}/${id}`)
      .toPromise()
      .catch(HandleError);
  }
  getWithExtraParams(queryParam: any): Promise<any> {
    const params: HttpParams = !queryParam
      ? new HttpParams()
      : new HttpParams().set("query", JSON.stringify(queryParam));
    return this.http
      .get(this.taskUrl + "/GetWithExtraParams", { params })
      .toPromise()
      .catch(HandleError);
  }
}
